import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { MenuService, OpcionMenu } from 'src/app/core/services/menu.service';
import { getConfig, getCurrentUser } from 'src/app/core/services/functions.service';
import { secureStorage } from 'src/app/core/secure.config';
import { environment } from 'src/environments/environment';
import { isString } from 'class-validator';

/**
 * AuthGuardService
 * @author Victorguz <victorguzber@gmail.com> June-2021
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router, private menuService: MenuService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isAuthenticated = this.auth.isAuthenticated()
    if (!isAuthenticated) {
      secureStorage.setItem(environment.LOCAL_LAST_URL, location.href)
      this.router.navigate([getConfig("route_on_forbidden")])
    }

    return isAuthenticated;
  }


}
